import React, { useCallback } from "react";
import Widget from "../../app/Widget";
import utils from "../../app/UtilityService";
import containerUtils, { getEmptyContent } from "../../utils/containerUtils";

const WidgetContainer = (props) => {
    const getInnerWidgetProps = useCallback(() => {
        //properties needed for the widget
        let extractedProps = containerUtils.extractComponentProps(props, {
            additionalProps: ["id", "visible", "pathId"],
            propsDefaults: { visible: true },
            aliases: { id: "storePath" }
        });

        let nestedWidgetId = extractedProps.id || extractedProps.pathId || props.data.class[0];

        return {
            id: nestedWidgetId,
            visible: extractedProps.visible
        };
    }, [props]);

    if (!props.data || !props.data.properties) {
        return getEmptyContent();
    }
    let innerWidgetsProps = getInnerWidgetProps();

    let visibility = innerWidgetsProps.visible;
    if (!visibility) {
        return getEmptyContent();
    }

    return <Widget key={innerWidgetsProps.id} id={innerWidgetsProps.id} />;
};

WidgetContainer.displayName = "WidgetContainer";

export default utils.connectComponent({
    actions: {
        loadWidget: "widget.loadWidget",
        reloadWidgetConfigData: "widget.reloadWidgetConfigData"
    }
})(WidgetContainer);
